export const SECTORS_URL = '/organization/v2/sectors';
